import { Grid2, Snackbar } from "@mui/material";
import styles from "../DomainHosted.module.scss";
import { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ModalPopup from "../../../../../../../GlobalComponents/Popup/ModalPopup";

const Dns = (props) => {
  const {
    popupCard,
    flushStateVariables,
    sslAuthChallenge,
    loading,
    step,
    data,
    error,
  } = props;
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
    setSnackbarOpen(true);
  };

  return (
    <>
      <ModalPopup
        header={"Verify DNS Challenge"}
        trigger={popupCard === "dns"}
        nextOnClick={step}
        nextpopup={"Create"}
        loading={loading}
        backPopup={"Cancel"}
        backOnClick={() => flushStateVariables()}
      >
        <Grid2 className={styles.headerRecord}>Record Name</Grid2>
        <Grid2 className={styles.display}>
          <Grid2 className={styles.record}>
            <Grid2 className={styles.acme}>_acme-challenge.{data}</Grid2>
            <Grid2 className={styles.copyvalue}>
              <ContentCopyIcon
                style={{ width: "20px", height: "20px" }}
                onClick={() => handleCopy(`_acme-challenge.${data}`)}
              />
            </Grid2>
          </Grid2>
          <Grid2 className={styles.header1}>TXT value</Grid2>
          {sslAuthChallenge?.keys?.map((key, index) => (
            <Grid2 key={index} className={styles.record1}>
              <Grid2 className={styles.keyValue}>{key?.value}</Grid2>
              <Grid2 className={styles.copyvalue}>
                <ContentCopyIcon
                  style={{ width: "20px", height: "20px" }}
                  onClick={() => handleCopy(key?.value)}
                />
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
        <Grid2 className={styles.error}>
          {error && "Something went wrong please try again"}
        </Grid2>
      </ModalPopup>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Value copied to clipboard"
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      />
    </>
  );
};

export default Dns;
